(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-track-order"] && !Shopify.designMode) return;
  try {
    
  function setupCpTracking(){
    document.querySelectorAll('[data-cp-tracking-form]').forEach(function(form){
      if(form.dataset.trackingBound)return;
      form.dataset.trackingBound='true';
      form.hidden=false;
      var carrier=form.querySelector('[data-cp-tracking-carrier]');
      var number=form.querySelector('[data-cp-tracking-number]');
      var endpoints={usps:['https://tools.usps.com/go/TrackConfirmAction','tLabels'],ups:['https://www.ups.com/track','tracknum'],fedex:['https://www.fedex.com/fedextrack/','trknbr'],dhl:['https://www.dhl.com/us-en/home/tracking.html','tracking-id']};
      function setCarrier(){var destination=endpoints[carrier.value];if(destination){form.action=destination[0];number.name=destination[1];}}
      carrier.addEventListener('change',setCarrier);
      form.addEventListener('submit',function(event){
        number.value=number.value.replace(/[\s-]+/g,'').toUpperCase();
        if(!endpoints[carrier.value]||!form.reportValidity()){event.preventDefault();return;}
        setCarrier();
        form.querySelector('[data-cp-tracking-status]').hidden=false;
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',setupCpTracking);}else{setupCpTracking();}
  document.addEventListener('shopify:section:load',setupCpTracking);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
